import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {
    TableContainer,
    ExpandedTableContainer,
    StyledEquipmentDetail
} from "./ResponsiveDataTable.styles";
import {useStore} from "../../../../hooks/useStore";
import moment from "moment";
import {message, Spin, Checkbox, Tag, Tooltip, Button} from "antd";
import {useObserver} from "mobx-react-lite";
import {useWindowSize} from "../../../../hooks/useWindowSize";
import {Link} from "react-router-dom";
import {Shortener} from "components/_defaultComponents/Shortener/Shortener";
import {AssignEquipmentModal} from "../modals/assignEquipmentModal/AssignEquipmentModal";
import {b64DecodeToUrl} from "utils/helpers";
import {UploadCourierEquipmentModal} from "../modals/uploadCourierEquipmentModal/UploadCourierEquipmentModal";
import {GiFullMotorcycleHelmet} from "react-icons/gi";
import {VscRefresh} from "react-icons/vsc";
import {HiDocumentPlus} from "react-icons/hi2";
import {FaCircleCheck, FaCircleXmark} from "react-icons/fa6";

import Icon from "@ant-design/icons";
import {courierEmploymentTypes} from "constants/constants";
import {ViewContractFileModal} from "components/_defaultComponents/SubCompanyPaymentContractsTable/ViewContractFileModal/ViewContractFileModal";
const TABLE_PREFIX = "courierEquipmentsTable";

const ResponsiveDataTable = ({
    data,
    loading,
    currentPage,
    setCurrentPage,
    pageSize,
    dataCount,
    recall,
    selectedRowKeys,
    onSelectionChange,
    onEquipmentAssigned = () => {}
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const {width} = useWindowSize();
    const isMobile = width ? width <= 640 : false;
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [loadingDetails, setLoadingDetails] = useState({});
    const [detailsData, setDetailsData] = useState({});
    const [selectedEquipmentIds, setSelectedEquipmentIds] = useState({});
    const [showSingleCourierModal, setShowSingleCourierModal] = useState(false);
    const [selectedSingleCourier, setSelectedSingleCourier] = useState(null);
    const [courierContractCreateLoading, setCourierContractCreateLoading] = useState(false);
    const [completeEquipmentAssignmentLoading, setCompleteEquipmentAssignmentLoading] = useState(
        false
    );
    const [rejectCourierEquipmentContractLoading, setRejectCourierEquipmentContractLoading] = useState(false);
    const [contractViewerVisible, setContractViewerVisible] = useState(false);
    const [contractViewerFiles, setContractViewerFiles] = useState([]);

    const handleViewContract = record => {
        const files = record?.courierEquipmentAgreement?.files || [];
        if (!files.length) return;
        setContractViewerFiles(files);
        setContractViewerVisible(true);
    };

    const loadExpandedRow = async rowKey => {
        const response = await stores.equipmentStore.courierEquipmentDetail({
            id: rowKey
        });
        if (response?.result) {
            setDetailsData(prev => ({...prev, [rowKey]: response.result}));
        }
    };

    const loadAllExpandedRows = async () => {
        const rowKeys = expandedRowKeys;
        for (const rowKey of rowKeys) {
            await loadExpandedRow(rowKey);
        }
    };
    const handleExpand = async (expanded, record) => {
        const rowKey = record._id;
        if (expanded) {
            setExpandedRowKeys([...expandedRowKeys, rowKey]);
            setLoadingDetails(prev => ({...prev, [rowKey]: true}));

            try {
                await loadExpandedRow(rowKey);
            } catch (error) {
                message.error("Detaylar yüklenirken hata oluştu");
            } finally {
                setLoadingDetails(prev => ({...prev, [rowKey]: false}));
            }
        } else {
            setExpandedRowKeys(expandedRowKeys.filter(key => key !== rowKey));
            setSelectedEquipmentIds(prev => {
                const newState = {...prev};
                delete newState[rowKey];
                return newState;
            });
        }
    };

    const renderExpandedRow = record => {
        const rowKey = record._id;
        const details = detailsData[rowKey];
        const isLoading = loadingDetails[rowKey];

        if (isLoading) {
            return (
                <div style={{textAlign: "center", padding: "20px"}}>
                    <Spin />
                </div>
            );
        }

        if (!details || !details.length) {
            return <div style={{padding: "20px"}}>Detay bulunamadı</div>;
        }

        const handleCheckboxChange = (equipmentId, checked) => {
            setSelectedEquipmentIds(prev => {
                const currentIds = prev[rowKey] || [];
                if (checked) {
                    return {
                        ...prev,
                        [rowKey]: [...currentIds, equipmentId]
                    };
                } else {
                    return {
                        ...prev,
                        [rowKey]: currentIds.filter(id => id !== equipmentId)
                    };
                }
            });
        };

        const handleDeleteWaitingAssignmentEquipment = async record => {
            try {
                console.log(record);
                const response = await stores.equipmentStore.deleteWaitingAssignmentEquipment({
                    courierEquipmentId: record._id
                });
                if (response?.success || response?.data?.success) {
                    recall();
                    loadAllExpandedRows();
                }
            } catch (error) {
                message.error("Atama Bekleyen Kurye Ekipmanı silinirken hata oluştu");
            }
        };
        const handleSelectAll = checked => {
            if (checked) {
                const allIds = details
                    .filter(item => ["handovered"].includes(item.status))
                    .map(item => item._id)
                    .filter(Boolean);
                setSelectedEquipmentIds(prev => ({
                    ...prev,
                    [rowKey]: allIds
                }));
            } else {
                setSelectedEquipmentIds(prev => ({
                    ...prev,
                    [rowKey]: []
                }));
            }
        };

        const currentSelectedIds = selectedEquipmentIds[rowKey] || [];
        const allSelected = details.length > 0 && currentSelectedIds.length === details.length;
        const indeterminate =
            currentSelectedIds.length > 0 && currentSelectedIds.length < details.length;

        const renderCellWithLabel = (label, content) => (
            <span className="expanded-cell" data-label={`${label}:`}>
                {content}
            </span>
        );

        const columns = [
            {
                title: (
                    <Tooltip
                        title={
                            !details.some(item => ["handovered"].includes(item.status))
                                ? "Hiç teslim edilmiş ekipman yok"
                                : ""
                        }
                    >
                        <Checkbox
                            checked={allSelected}
                            indeterminate={indeterminate}
                            onChange={e => handleSelectAll(e.target.checked)}
                            disabled={!details.some(item => ["handovered"].includes(item.status))}
                        />
                    </Tooltip>
                ),
                key: "checkbox",
                width: 50,
                render: (_, record) =>
                    renderCellWithLabel(
                        "Seç",
                        <Tooltip
                            title={
                                record?.status !== "handovered"
                                    ? "Ekipman teslim edilmişse seçilebilir"
                                    : ""
                            }
                        >
                            <Checkbox
                                checked={currentSelectedIds.includes(record._id)}
                                onChange={e => handleCheckboxChange(record._id, e.target.checked)}
                                disabled={!["handovered"].includes(record.status)}
                            />
                        </Tooltip>
                    )
            },
            {
                title: "Ekipman Adı",
                dataIndex: "equipmentName",
                key: "equipmentName",
                render: equipmentName => renderCellWithLabel("Ekipman Adı", equipmentName || "-")
            },
            {
                title: "Ekipman Türü",
                dataIndex: "equipmentType",
                key: "equipmentType",
                render: equipmentType => renderCellWithLabel("Ekipman Türü", equipmentType || "-")
            },
            {
                title: "Renk",
                dataIndex: "equipmentColor",
                key: "color",
                render: equipmentColor => renderCellWithLabel("Renk", equipmentColor || "-")
            },
            {
                title: "Beden",
                dataIndex: "equipmentSize",
                key: "size",
                render: equipmentSize => renderCellWithLabel("Beden", equipmentSize || "-")
            },
            {
                title: "Fiyat",
                dataIndex: "price",
                key: "price",
                render: price => renderCellWithLabel("Fiyat", price ? `${price} ₺` : "-")
            },
            {
                title: "Teslim Tarihi",
                dataIndex: "handoverDate",
                key: "handoverDate",
                render: date =>
                    renderCellWithLabel(
                        "Teslim Tarihi",
                        date ? moment(date).format("DD.MM.YYYY") : "-"
                    )
            },
            {
                title: "İade Tarihi",
                dataIndex: "returnDate",
                key: "returnDate",
                render: date =>
                    renderCellWithLabel(
                        "İade Tarihi",
                        date ? moment(date).format("DD.MM.YYYY") : "-"
                    )
            },
            {
                title: "Durum",
                dataIndex: "status",
                key: "status",
                render: (status, row) =>
                    renderCellWithLabel(
                        "Durum",
                        status === "returned" ? (
                            "İade Alındı"
                        ) : status === "handovered" ? (
                            "Teslim Verildi"
                        ) : status === "pendingAssignment" ? (
                            <>
                                Atama Beklemede
                                <Tooltip
                                    title={
                                        !stores.meStore.checkRole(
                                            "deleteWaitingAssignmentEquipment"
                                        )
                                            ? "Atama Bekleyen Kurye Ekipmanı silme yetkiniz yok"
                                            : "Atama Bekleyen Kurye Ekipmanı Sil"
                                    }
                                >
                                    <Button
                                        size="small"
                                        type="danger"
                                        onClick={() => handleDeleteWaitingAssignmentEquipment(row)}
                                        disabled={
                                            !stores.meStore.checkRole(
                                                "deleteWaitingAssignmentEquipment"
                                            )
                                        }
                                    >
                                        Kaldır
                                    </Button>
                                </Tooltip>
                            </>
                        ) : (
                            "-"
                        )
                    )
            }
        ];

        return (
            <StyledEquipmentDetail>
                <ExpandedTableContainer
                    dataSource={details}
                    columns={columns}
                    pagination={false}
                    rowKey={record => record?._id || Math.random()}
                    size="small"
                    scroll={!isMobile ? {x: 768} : undefined}
                />
            </StyledEquipmentDetail>
        );
    };

    const handleReturnEquipment = async record => {
        const courierId = record.courierId || record._id;
        const selectedIds = selectedEquipmentIds[courierId] || [];

        if (selectedIds.length === 0) {
            message.warning("Lütfen iade almak için en az bir ekipman seçin");
            return;
        }

        try {
            const response = await stores.equipmentStore.returnEquipmentFromCourier({
                ids: selectedIds
            });
            if (response) {
                setExpandedRowKeys(expandedRowKeys.filter(key => key !== courierId));
                setSelectedEquipmentIds(prev => {
                    const newState = {...prev};
                    delete newState[courierId];
                    return newState;
                });
                if (recall) recall();
            }
        } catch (error) {
            message.error("İade alma işlemi sırasında hata oluştu");
        }
    };

    const handleAssignEquipmentToSingleCourier = record => {
        setSelectedSingleCourier(record);
        setShowSingleCourierModal(true);
    };

    const handleCreateContract = async courier => {
        try {
            setCourierContractCreateLoading(true);
            const courierId = courier?._id;
            const values = {
                courierId: courierId,
                contractName: "courierEquipmentAgreement"
            };
            const response = await stores.contractStore.generateContractPreview(values);
            const contract = response?.contract;
            const base64Data = contract?.base64File;
            const blobUrl = await b64DecodeToUrl(base64Data);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `${contract?.name}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            message.success("Sözleşme oluşturuldu/indirildi");
        } catch (error) {
            message.error("Sözleşme oluşturulamadı/indirilemedi");
        } finally {
            setCourierContractCreateLoading(false);
        }
    };

    const handleCompleteEquipmentAssignment = async record => {
        setCompleteEquipmentAssignmentLoading(true);
        try {
            const courierId = record._id;
            if (!courierId) {
                message.warning("Kurye bilgileri bulunamadı");
                return;
            }
            const response = await stores.equipmentStore.completeEquipmentAssignment({
                courierId: courierId
            });
            if (response?.success || response?.data?.success) {
                recall?.();
                loadAllExpandedRows();
            }
        } catch (error) {
            //
        } finally {
            setCompleteEquipmentAssignmentLoading(false);
        }
    };

    const handleRejectCourierEquipmentContract = async record => {
        setRejectCourierEquipmentContractLoading(true);
        try {
            const courierId = record._id;
            if (!courierId) {
                message.warning("Kurye bilgileri bulunamadı");
                return;
            }
            const response = await stores.equipmentStore.rejectCourierEquipmentContract({
                courierId: courierId
            });
            if (response?.success || response?.data?.success) {
                recall?.();
                loadAllExpandedRows();
            }
        } catch (error) {
            //
        } finally {
            setRejectCourierEquipmentContractLoading(false);
        }
    };

    const renderActionColumn = record => (
        <span data-label="Aksiyon:" style={{display: "flex", justifyContent: "flex-end"}}>
            <Tooltip
                title={
                    !stores.meStore.checkRole("assignCourierEquipment")
                        ? "Ekipman ata yetkiniz yok"
                        : "Ekipman Ata"
                }
            >
                <Button
                    type="text"
                    size="small"
                    onClick={() => handleAssignEquipmentToSingleCourier(record)}
                    disabled={!stores.meStore.checkRole("assignCourierEquipment")}
                    style={{padding: "0 2px"}}
                >
                    <Icon component={GiFullMotorcycleHelmet} style={{fontSize: 28}} />
                </Button>
            </Tooltip>
            <Tooltip
                title={
                    !stores.meStore.checkRole("returnCourierEquipment")
                        ? "İade alma yetkiniz yok"
                        : !(record?.handoveredEquipments?.length > 0)
                        ? "Hiç teslim edilmiş ekipman yok"
                        : "İade Al"
                }
            >
                <Button
                    size="small"
                    type="text"
                    onClick={() => handleReturnEquipment(record)}
                    disabled={
                        !stores.meStore.checkRole("returnCourierEquipment") ||
                        !(record?.handoveredEquipments?.length > 0)
                    }
                    style={{padding: "0 2px"}}
                >
                    <Icon
                        component={VscRefresh}
                        style={{fontSize: 24, transform: "scale(-1, 1) rotate(100deg)"}}
                    />
                </Button>
            </Tooltip>
            <Tooltip
                title={
                    !stores.meStore.checkRole("createCourierEquipmentContract")
                        ? "Sözleşme oluşturma yetkiniz yok"
                        : "Sözleşme Oluştur"
                }
            >
                <Button
                    size="small"
                    type="text"
                    onClick={() => handleCreateContract(record)}
                    loading={courierContractCreateLoading}
                    disabled={!stores.meStore.checkRole("createCourierEquipmentContract")}
                    style={{padding: "0 2px"}}
                >
                    <Icon component={HiDocumentPlus} style={{fontSize: 24}} />
                </Button>
            </Tooltip>
            <Tooltip
                title={
                    !stores.meStore.checkRole("uploadCourierEquipmentContract")
                        ? "Yükleme yetkiniz yok"
                        : "Sözleşme Yükle"
                }
            >
                <div>
                    <UploadCourierEquipmentModal
                        onSuccess={() => {
                            recall();
                        }}
                        courierId={record._id}
                        disabled={!stores.meStore.checkRole("uploadCourierEquipmentContract")}
                    />
                </div>
            </Tooltip>
            <Tooltip
                title={
                    !stores.meStore.checkRole("approveCourierEquipmentContract")
                        ? "Ekipman atama onay yetkiniz yok"
                        : record?.equipmentInfo?.contractStatus !== "pendingApproval"
                        ? "Sadece sözleşme onayı bekleyen kuryelerde, atama onaylayabilirsiniz"
                        : "Atama Onayla"
                }
            >
                <Button
                    size="small"
                    type="text"
                    onClick={() => handleCompleteEquipmentAssignment(record)}
                    disabled={
                        !stores.meStore.checkRole("approveCourierEquipmentContract") ||
                        record?.equipmentInfo?.contractStatus !== "pendingApproval"
                    }
                    loading={completeEquipmentAssignmentLoading}
                    style={{padding: "0 2px"}}
                >
                    <Icon component={FaCircleCheck} style={{fontSize: 24}} />
                </Button>
            </Tooltip>
            {stores.meStore.checkRole("rejectCourierEquipmentContract") && (
                <Tooltip
                    title={
                        record?.equipmentInfo?.contractStatus !== "pendingApproval" &&
                        record?.equipmentInfo?.contractStatus !== "approved"
                            ? "Sadece onay bekleyen veya onaylı sözleşmelerde ret yapabilirsiniz"
                            : "Sözleşmeyi Reddet"
                    }
                >
                    <Button
                        size="small"
                        type="text"
                        onClick={() => handleRejectCourierEquipmentContract(record)}
                        disabled={
                            record?.equipmentInfo?.contractStatus !== "pendingApproval" &&
                            record?.equipmentInfo?.contractStatus !== "approved"
                        }
                        loading={rejectCourierEquipmentContractLoading}
                        style={{padding: "0 2px"}}
                    >
                        <Icon component={FaCircleXmark} style={{fontSize: 24, color: "red"}} />
                    </Button>
                </Tooltip>
            )}
        </span>
    );

    const rowSelection = {
        selectedRowKeys: selectedRowKeys || [],
        onChange: selectedKeys => {
            if (onSelectionChange) {
                onSelectionChange(selectedKeys);
            }
        },
        preserveSelectedRowKeys: true
    };

    return useObserver(() => (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                scroll={!isMobile ? {x: 768} : undefined}
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                    pageSize: pageSize
                }}
                rowKey={record => record._id}
                dataSource={data || []}
                loading={loading}
                rowSelection={rowSelection}
                expandable={{
                    expandedRowRender: renderExpandedRow,
                    expandedRowKeys: expandedRowKeys,
                    onExpand: handleExpand
                }}
                size="small"
            >
                <TableContainer.Column
                    dataIndex="fullname"
                    title="Kurye İsmi"
                    render={(fullname, record) => (
                        <span data-testid="fullname" data-label="Kurye İsmi:">
                            <Link target="_blank" to={`/couriers/${record._id}`}>
                                {fullname || "-"}
                            </Link>
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="tckn"
                    title="Kurye TC"
                    render={tckn => (
                        <span data-testid="tckn" data-label="Kurye TC:">
                            {tckn || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="cellPhone"
                    title="Kurye Telefon"
                    render={cellPhone => (
                        <span data-testid="cellPhone" data-label="Kurye Telefon:">
                            {cellPhone || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="zoneInfo"
                    title="Kurye Bölge"
                    render={zoneInfo => (
                        <span data-testid="zoneInfo" data-label="Kurye Bölge:">
                            <Shortener
                                text={zoneInfo?.map(item => item.zoneName).join(", ") || "-"}
                                length={30}
                            />
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="projectName"
                    title="Proje"
                    render={projectName => (
                        <span data-testid="project" data-label="Proje:">
                            {projectName}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="employmentType"
                    title="Çalışma Şekli"
                    render={employmentType => (
                        <span data-testid="employmentType" data-label="Çalışma Şekli:">
                            {courierEmploymentTypes.find(type => type.value === employmentType)
                                ?.name || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex={["equipmentInfo", "lastHandoveredAt"]}
                    title="Ekipman Atama Tarihi"
                    render={(lastHandoveredAt, record) => (
                        <span data-testid="lastHandoveredAt" data-label="Ekipman Atama Tarihi:">
                            {lastHandoveredAt ? moment(lastHandoveredAt).format("DD.MM.YYYY") : "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex={["equipmentInfo", "contractStatus"]}
                    title="Sözleşme Durumu"
                    render={(contractStatus, record) => (
                        <span data-testid="contractStatus" data-label="Sözleşme Durumu:">
                            {contractStatus === "approved" ? (
                                <Tag
                                    color="green"
                                    style={{cursor: "pointer", textDecoration: "underline"}}
                                    onClick={() => handleViewContract(record)}
                                >
                                    Onaylı
                                </Tag>
                            ) : contractStatus === "pendingApproval" ? (
                                <Tag
                                    color="orange"
                                    style={{cursor: "pointer", textDecoration: "underline"}}
                                    onClick={() => handleViewContract(record)}
                                >
                                    Onay Bekliyor
                                </Tag>
                            ) : (
                                <Tag color="orange">Sözleşme Beklemede</Tag>
                            )}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex={["equipmentInfo", "assignmentStatus"]}
                    title="Atama Durumu"
                    render={assignmentStatus => (
                        <span data-testid="assignmentStatus" data-label="Atama Durumu:">
                            {assignmentStatus === "assigned" ? (
                                <Tag color="green">Atandı</Tag>
                            ) : (
                                <Tag color="orange">Atama Beklemede</Tag>
                            )}
                        </span>
                    )}
                />
                <TableContainer.Column
                    align="right"
                    title="Aksiyon"
                    render={record => (
                        <span data-label="Aksiyon:">{renderActionColumn(record)}</span>
                    )}
                />
            </TableContainer>

            <ViewContractFileModal
                visible={contractViewerVisible}
                onCancel={() => {
                    setContractViewerVisible(false);
                    setContractViewerFiles([]);
                }}
                files={contractViewerFiles}
            />
            <AssignEquipmentModal
                visibility={showSingleCourierModal}
                recall={recall}
                changeVisibility={setShowSingleCourierModal}
                onCancel={() => {
                    setShowSingleCourierModal(false);
                    setSelectedSingleCourier(null);
                }}
                onOk={({equipmentAssignedCouriers}) => {
                    setShowSingleCourierModal(false);
                    setSelectedSingleCourier(null);
                    loadAllExpandedRows();
                    onEquipmentAssigned({updatedRecords: equipmentAssignedCouriers || []});
                }}
                selectedCouriers={selectedSingleCourier ? [selectedSingleCourier] : []}
                onCourierRemove={() => {}}
                singleCourierMode={true}
            />
        </>
    ));
};

export default ResponsiveDataTable;
